// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "antd";
import FormField from "../../components/FormField";
import { SettingsProps } from "../../types/SettingsTypes";

const SettingsInputFormSection: React.FunctionComponent<SettingsProps> = (
  props: SettingsProps
) => {
  const { t } = useTranslation();

  const { editMode = true } = props;

  return (
    <>
      <Row>
        <Col xs={24} sm={12} lg={8}>
          <FormField
            labelName={t("settings.news_main_image_size")}
            inputId="newsMainImageSize"
            required={true}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            addonAfter={t("settings.bytes")}
            type="number"
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <FormField
            labelName={t("settings.news_main_image_width")}
            inputId="newsMainImageWidth"
            required={true}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            addonAfter="pixels"
            type="number"
          />
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <FormField
            labelName={t("settings.news_main_image_height")}
            inputId="newsMainImageHeight"
            required={true}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            addonAfter="pixels"
            type="number"
          />
        </Col>
      </Row>
    </>
  );
};

SettingsInputFormSection.defaultProps = {
  editMode: true
};

export default SettingsInputFormSection;
